import { useCallback, useEffect, useState } from "react";
import PortalRequestsAndFormsService from "../../../services/portalRequestsAndFormsService";
import { ITemplate } from "../types";
import { NavigateFunction, useNavigate } from "react-router";

export const useFetchData = (contractNumber: string) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const navigate: NavigateFunction = useNavigate();

  const [data, setData] = useState<ITemplate[]>([]);

  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);

      const res =
        await PortalRequestsAndFormsService.fetchTemplates(contractNumber);

      setData(res);

      setIsLoading(false);
    } catch (e: any) {
      (e.status === 404 || e.status === 400) && navigate("/not-found");

      setIsLoading(false);
    }
  }, [contractNumber, navigate]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { isLoading, data };
};
